import { SubFundCumulativeBreakdownTableData } from './SubFundCumulativeBreakdownTable.component';
import SecondLevelTable from './SecondLevelTable.component';
import { UnfoldLess } from '@mui/icons-material';

const SecondLevelTableWrapper = () => [
  (rowData: SubFundCumulativeBreakdownTableData) => {
    const render = () => (
      <SecondLevelTable
        title={'Underling Assets'}
        data={rowData.underlyingAssets}
      />
    );
    return {
      openIcon: UnfoldLess,
      render,
      disabled: rowData.underlyingAssets.length ? false : true,
    };
  },
];

export default SecondLevelTableWrapper;
